import { Redirect } from 'expo-router';
import React, { useEffect, useRef } from 'react';
import { logErrorWithContext } from 'shared/utils/sentry/sentry';
import {
  ErrorSeverity,
  FeatureArea,
  ResponsibleTeam,
} from 'shared/utils/sentry/sentry.constants';

// this route is used as the redirect uri for plaid oauth app2app flows
// A user should not actually land on this screen as they should be
// which routed users back to the screen they were on before starting the oauth flow
// This is a fallback in case that deeplink handling fails for some reason
const OAuth = () => {
  const loggedRef = useRef(false);

  useEffect(() => {
    if (loggedRef.current) {
      return;
    }

    loggedRef.current = true;
    logErrorWithContext('Plaid App2App fallback, deeplink not handled', {
      featureArea: FeatureArea.PLAID,
      responsibleTeam: ResponsibleTeam.LENDING_CREDIT,
      severity: ErrorSeverity.MEDIUM,
    });
  }, []);

  return <Redirect href="/" />;
};

export default OAuth;
